import { render, staticRenderFns } from "./form-radio.vue?vue&type=template&id=e0d90d8a&"
import script from "./form-radio.vue?vue&type=script&lang=js&"
export * from "./form-radio.vue?vue&type=script&lang=js&"
import style0 from "./form-radio.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports